import React, { useState } from 'react';
import './InfoCircle.css';

const InfoCircle = ({ text, white = false }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div className="info-circle-container">
            <i 
                className={`fas fa-info-circle info-icon ${white ? 'info-icon-white' : ''}`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            ></i>
            {isHovered && (
                <div className={`info-tooltip ${white ? '' : 'info-tooltip-white'}`}>
                    {text}
                </div>
            )}
        </div>
    );
};

export default InfoCircle; 